export default "__VITE_ASSET__Yrmt$NEz__"